import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftraggeber, IDienstleistung, IErrorResponse, IProfileDto, IRolle } from "../types/Types";
import { ErrorAPI } from "./ErrorAPI";

/**
 * @author mb
 */
const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "office",
    credentials: 'include'
});

const baseQueryWithErrorHandling = async (args: any, api: any, extraOptions: any) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error) {
        const errorMessage = (result.error?.data as any)?.text || (result.error?.data as any)?.message || 'Unknown error';
        const status = (result.error as any)?.status || 'UNKNOWN';

        // Log error via ErrorAPI
        try {
            await api.dispatch(ErrorAPI.endpoints.createLog.initiate({
                status: String(status),
                api: "office",
                message: errorMessage
            }));
        } catch (logError) {
            console.error('Failed to log error:', logError);
        }
    }
    return result;
};
export const OfficeAPI = createApi({
    reducerPath: "officeAPI",
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: ['officeAPI'], // for caching
    endpoints: (builder) => ({
        getRollen: builder.mutation<IRolle[], void>(
            {
                query: () => ({
                    url: 'roles/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        getAuftraggeberListe: builder.mutation<IAuftraggeber[], void>(
            {
                query: () => ({
                    url: 'auftraggeberliste',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        getVerkaeuferListe: builder.mutation<{ uid: string, name: string }[], string>(
            {
                query: (uid) => ({
                    url: 'verkaeuferliste/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        getDienstleistungsListe: builder.mutation<IDienstleistung[], void>(
            {
                query: () => ({
                    url: 'dienstleistungsliste/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),




    })
});

export const {

    useGetAuftraggeberListeMutation,
    useGetVerkaeuferListeMutation,
    useGetDienstleistungsListeMutation,

} = OfficeAPI;
